<template>
  <div class="odp-modal-mobile">
    <div class="odp-modal-mobile__title">
      Отделение
    </div>
    <div class="odp-modal-mobile__item odp-modal-mobile__item-bold">
      <svg
        width="16px"
        height="16px"
      >
        <use xlink:href="#point" />
      </svg>
      {{ ODPPreview.address }}
    </div>
    <div
      v-if="ODPPreview.phone"
      class="odp-modal-mobile__item"
    >
      <svg
        width="16px"
        height="16px"
      >
        <use xlink:href="#tel" />
      </svg>
      {{ ODPPreview.phone }}
    </div>
    <div
      v-if="ODPPreview.scheduleShort"
      class="odp-modal-mobile__item"
    >
      <svg
        width="16px"
        height="16px"
      >
        <use xlink:href="#clock2" />
      </svg>
      {{ ODPPreview.scheduleShort }}
    </div>
  </div>
</template>
<script>

export default {
  name: 'ODPModalMobile',
  props: {
    ODPPreview: Object,
  },
};
</script>

<style lang="scss" scoped>
.odp-modal-mobile {
  width: 100%;
  padding: 16px 0 0 0;
  border-radius: 0 0 20px 20px;
  background-color: #FAFBFC;
  z-index: 1;
}
.odp-modal-mobile__title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #50616F;
}
.odp-modal-mobile__item {
  display: flex;
  align-items: flex-start;
  font-size: 13px;
  font-weight: 400;
  line-height: 17px;
  color: #50616F;
  svg {
    margin-right: 8px;
  }
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
}
.odp-modal-mobile__item-bold {
  font-weight: 600;
}

</style>
